import React from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export const gallerySortByOptions = [
  {
    value: "publishedDate",
    label: (
      <span data-qa="sort-by-date">
        <IDHFormattedMessage id="ws_date" defaultMessage="Date" />
      </span>
    ),
  },
  { value: "er", label: <span data-qa="sort-by-er">ER</span> },
  {
    value: "likes",
    label: (
      <span data-qa="sort-by-likes">
        <IDHFormattedMessage id="ws_likes" defaultMessage="Likes" />
      </span>
    ),
  },
  {
    value: "views",
    label: (
      <span data-qa="sort-by-views">
        <IDHFormattedMessage id="ws_views" defaultMessage="Views" />
      </span>
    ),
  },
  {
    value: "comments",
    label: (
      <span data-qa="sort-by-comments">
        <IDHFormattedMessage id="ws_comments" defaultMessage="Comments" />
      </span>
    ),
  },
] as const;

export type GallerySortByKey = (typeof gallerySortByOptions)[number]["value"];
